<template>
  <qc-container title="订单管理">
    <page-request ref="table" url="/api/mgr/order/repair/list" :table-header="tableHeader" :expend="expend" :prop="{status:activeName}" :op-width="200">
      <div class="flex-cc full">
        <el-tabs v-model="activeName">
          <el-tab-pane label="全部" name=""></el-tab-pane>
          <el-tab-pane label="待处理" name="0"></el-tab-pane>
          <el-tab-pane label="待支付" name="1"></el-tab-pane>
          <el-tab-pane label="维修中" name="2"></el-tab-pane>
          <el-tab-pane label="待确认" name="3"></el-tab-pane>
          <el-tab-pane label="已完成" name="4"></el-tab-pane>
          <el-tab-pane label="已取消" name="5"></el-tab-pane>
        </el-tabs>
<!--        <div class="btn-box">
          <export-excel @action="addExportTask" ref="exportExcel" file-name="shop-repair-export.xlsx" task-key="repair" task-name="维修订单列表" button-name="批量导出"></export-excel>
        </div>-->
      </div>
      <template #op="scope">
        <b-button @click="orderDetail(scope.row.id)">详情</b-button>
      </template>
    </page-request>
  </qc-container>
</template>

<script>
import QcContainer from "@/components/el/layout/qc-container.vue";
import BButton from "@/components/el/b-button.vue";
import TButton from "@/components/el/t-button.vue";
import PageRequest from "@/components/base/page-request.vue";
import ExportExcel from "@/components/base/ExportExcel.vue";

export default {
  name: "repair-order",
  components: {ExportExcel, PageRequest, TButton, BButton, QcContainer},
  data() {
    return {
      activeName:"",
      tableHeader: [
        {type: "repairGoods",prop:"goodsList", label: "维修商品",minWidth:300},
        {prop: "code", label: "维修编号",width:200},
        {prop: "nickname", label: "买家名称",width:100},
        {prop: "mobile", label: "买家手机号码",width:140},
        {prop:"statusDesc",label: "状态",width:100},
        {prop: "createTime", label: "申请时间",width:160},
      ],
      expend: [
        {label: "维修编号", prop: "code"},
        {label: "商品名称", prop: "name"},
        {label: "设备编号", prop: "subCode"},
        {label: "买家名称", prop: "nickname"},
        {label: "买家手机号码", prop: "mobile"},
        {label: "商家名称", prop: "shopName"},
        {label: "申请时间", start: "startDate", end: "endDate", type: "daterange"},
      ],
    }
  },
  mixins: [tableBase],
  methods: {
    orderDetail(id){
      this.toRouter("/index/lease/repair/detail",{id:id});
    }
  },
  mounted() {

  }
}
</script>

<style scoped>

</style>
